// Project case study data — content pulled from the original jpkuster.com
// project pages, plus a comprehensive Revolution Cannabis case owned and written by JP.

export const PROJECTS = [
  {
    slug: "revolution-cannabis",
    title: "Revolution Cannabis",
    category: "Brand Leadership",
    year: "2018 – 2022",
    client: "Revolution Global",
    role: "Marketing Manager — Creative, Brand Strategy, Copy, Social & Campaigns",
    timeline: "Four-year in-house engagement",
    tagline:
      "Building Revolution Cannabis into a top 5 High Times brand and the most award-winning operator in Illinois cannabis — across identity, creative, copy, social, product and culture.",
    summary:
      "A four-year in-house brand program covering creative and brand strategy, copywriting, social strategy, product campaigns, and cultural partnerships. Revolution became a top 5 High Times Cannabis Brand in 2020 and 2021, won more than 40 Cannabis Cup awards across the engagement, and grew social following from near-zero to 155,000+ — a 47,000% lift in under three years.",
    challenge:
      "A regulated, fast-consolidating industry where most brands were either sterile and pharmaceutical or stuck in stoner stereotypes. Revolution needed a clear cultural point of view, a consistent voice, and a product story that could travel across cultivar launches, packaging, dispensary POS, social, advocacy, and retail.",
    approach: [
      "Defined the brand platform, voice, and messaging architecture that every team operated from — product, sales, retail, events, advocacy.",
      "Led creative direction on 13+ cultivar and product launches from 2020 – 2022, including packaging, launch campaigns, and retail merchandising.",
      "Built the social engine: content pillars, editorial calendar, weekly cadence, community management standards, and an artist-led storytelling approach.",
      "Wrote brand and product copy across web, packaging, dispensary collateral, newsletters, and PR — including Farm Bill and legalization advocacy.",
      "Partnered with cultural brands (Lyrical Lemonade, Riot Fest, Jugrnaut, regional artists) to plant Revolution in the cultural moments its audience already cared about.",
      "Stood up the in-house content studio — product photography, lifestyle shoots, apparel drops, retail flyers, and multi-channel campaign assets.",
    ],
    outcome:
      "Revolution was named a Top 5 Cannabis Brand by High Times in 2020 and 2021, ranked #1 in Illinois, and took home 40+ Cannabis Cup awards across the four-year engagement. Social grew from near-zero to 155,000+ followers (47,000% in under three years). The brand system and editorial voice continue to anchor the company today.",
    metrics: [
      { k: "Top 5", v: "High Times Brand — 2020 & 2021" },
      { k: "40+", v: "Cannabis Cup Awards (2019 – 2022)" },
      { k: "47,000%", v: "Social growth in under 3 years" },
      { k: "155K+", v: "Followers built from zero" },
    ],
    press: [
      {
        title: "Revolution Extends Its Unrivaled Cannabis Cup Illinois Track Record to 2021",
        source: "PR Newswire",
        href: "https://www.prnewswire.com/news-releases/revolution-extends-its-unrivaled-cannabis-cup-illinois-track-record-to-2021-301443722.html",
      },
      {
        title: "The People Have Chosen",
        source: "High Times",
        href: "https://hightimes.com/news/the-people-have-chosen/",
      },
      {
        title: "Revolution Nearly Sweeps the Illinois Cannabis Cup",
        source: "Chicago Tribune",
        href: "https://www.chicagotribune.com/2020/09/28/revolution-cannabis-nearly-sweeps-the-illinois-cannabis-cup-but-some-reviewers-question-the-process/",
      },
    ],
    hero: "https://cdn.crevado.com/artists/1287474/pages/4726534_original-2.jpg",
    sections: [
      {
        title: "Campaign Photography",
        description:
          "Campaign and product photography used across launches, retail environments, and paid media.",
        layout: "feature",
        images: [
          "https://cdn.crevado.com/artists/1287474/artwork/14072514_original-1.jpg",
          "https://cdn.crevado.com/artists/1287474/artwork/14072510_original-1.jpg",
          "https://cdn.crevado.com/artists/1287474/artwork/13914042_original-1.jpg",
          "https://cdn.crevado.com/artists/1287474/artwork/13914018_original-1.jpg",
          "https://cdn.crevado.com/artists/1287474/artwork/13913814_original-1.jpg",
          "https://cdn.crevado.com/artists/1287474/artwork/13913794_original-1.jpg",
        ],
      },
      {
        title: "Digital Campaigns",
        description:
          "Social-first creative built to carry Revolution into culture — editorial campaigns, launch moments, and artist collaborations.",
        layout: "square",
        images: [
          "https://static.wixstatic.com/media/c8fd28_ebece39dd3574397bd65360deaf7b9b0~mv2.png/v1/fill/w_900,h_900,q_90,enc_avif,quality_auto/c8fd28_ebece39dd3574397bd65360deaf7b9b0~mv2.png",
          "https://static.wixstatic.com/media/c8fd28_7bcbd6fd59e9465b8a18856affc2f501~mv2.png/v1/fill/w_900,h_900,q_90,enc_avif,quality_auto/c8fd28_7bcbd6fd59e9465b8a18856affc2f501~mv2.png",
          "https://static.wixstatic.com/media/c8fd28_c82e01dde55a49d284de6400fd329833~mv2.png/v1/fill/w_900,h_900,q_90,enc_avif,quality_auto/c8fd28_c82e01dde55a49d284de6400fd329833~mv2.png",
          "https://static.wixstatic.com/media/c8fd28_d441ce166402424e9dbbfc9d66665dfa~mv2.png/v1/fill/w_900,h_900,q_90,enc_avif,quality_auto/c8fd28_d441ce166402424e9dbbfc9d66665dfa~mv2.png",
          "https://static.wixstatic.com/media/c8fd28_e8351f3cbf8b44c983306fc391d4f887~mv2.jpg/v1/fill/w_900,h_900,q_90,enc_avif,quality_auto/c8fd28_e8351f3cbf8b44c983306fc391d4f887~mv2.jpg",
          "https://static.wixstatic.com/media/c8fd28_9ba570bfaddd40e0a2d71e557edc469b~mv2.jpg/v1/fill/w_900,h_900,q_90,enc_avif,quality_auto/c8fd28_9ba570bfaddd40e0a2d71e557edc469b~mv2.jpg",
          "https://static.wixstatic.com/media/c8fd28_87d47286416f4ec4aa5763982b74498d~mv2.jpg/v1/fill/w_900,h_900,q_90,enc_avif,quality_auto/c8fd28_87d47286416f4ec4aa5763982b74498d~mv2.jpg",
          "https://static.wixstatic.com/media/c8fd28_ce76ff4f5a324cc5998b012ef9216b0e~mv2.jpg/v1/fill/w_900,h_900,q_90,enc_avif,quality_auto/c8fd28_ce76ff4f5a324cc5998b012ef9216b0e~mv2.jpg",
        ],
      },
      {
        title: "Product & Drops",
        description:
          "Launch visuals for cultivar releases, product drops, and category-defining photography across the portfolio.",
        layout: "wide",
        images: [
          "https://static.wixstatic.com/media/c8fd28_7244a20cf3bb483d9a6243bf68dbe411~mv2.jpg/v1/fit/w_1600,h_700,q_90,enc_avif,quality_auto/c8fd28_7244a20cf3bb483d9a6243bf68dbe411~mv2.jpg",
          "https://static.wixstatic.com/media/c8fd28_5ded82a3756748edb0e779b0dbbaa9f5~mv2.jpg/v1/fit/w_1600,h_700,q_90,enc_avif,quality_auto/c8fd28_5ded82a3756748edb0e779b0dbbaa9f5~mv2.jpg",
        ],
      },
      {
        title: "Apparel & Merch",
        description:
          "Branded apparel drops designed to extend Revolution beyond the dispensary — cultural product, not swag.",
        layout: "square",
        images: [
          "https://static.wixstatic.com/media/c8fd28_b78f7a0d939b40cbbbd4b369f78076d0~mv2.png/v1/fill/w_900,h_900,q_90,enc_avif,quality_auto/c8fd28_b78f7a0d939b40cbbbd4b369f78076d0~mv2.png",
          "https://static.wixstatic.com/media/c8fd28_e8ef1314595a430fb07dab86672b0697~mv2.png/v1/fill/w_900,h_900,q_90,enc_avif,quality_auto/c8fd28_e8ef1314595a430fb07dab86672b0697~mv2.png",
          "https://static.wixstatic.com/media/c8fd28_2665d540344647af86ee33e8416f02e6~mv2.png/v1/fill/w_900,h_900,q_90,enc_avif,quality_auto/c8fd28_2665d540344647af86ee33e8416f02e6~mv2.png",
          "https://static.wixstatic.com/media/c8fd28_e5f6c2a51de143c1a99a720d63430438~mv2.png/v1/fill/w_900,h_900,q_90,enc_avif,quality_auto/c8fd28_e5f6c2a51de143c1a99a720d63430438~mv2.png",
          "https://static.wixstatic.com/media/c8fd28_81917b2d7a1949a9a8834ae108e1380c~mv2.png/v1/fill/w_900,h_900,q_90,enc_avif,quality_auto/c8fd28_81917b2d7a1949a9a8834ae108e1380c~mv2.png",
          "https://static.wixstatic.com/media/c8fd28_ff156ba7650944309eb163abf9e07ba7~mv2.png/v1/fill/w_900,h_900,q_90,enc_avif,quality_auto/c8fd28_ff156ba7650944309eb163abf9e07ba7~mv2.png",
        ],
      },
      {
        title: "Retail Flyers & POS",
        description:
          "In-store marketing, dispensary flyers, and point-of-sale collateral supporting monthly promotions and product launches.",
        layout: "portrait",
        images: [
          "https://static.wixstatic.com/media/c8fd28_dcf7fe8836de480fbcea8ab7d7e6fde3~mv2.jpg/v1/fill/w_750,h_975,q_90,enc_avif,quality_auto/c8fd28_dcf7fe8836de480fbcea8ab7d7e6fde3~mv2.jpg",
          "https://static.wixstatic.com/media/c8fd28_70899695f44747b58c127624ecea2921~mv2.jpg/v1/fill/w_750,h_975,q_90,enc_avif,quality_auto/c8fd28_70899695f44747b58c127624ecea2921~mv2.jpg",
          "https://static.wixstatic.com/media/c8fd28_f33f9c9385fa44baa1b6b4104d99454d~mv2.jpg/v1/fill/w_750,h_975,q_90,enc_avif,quality_auto/c8fd28_f33f9c9385fa44baa1b6b4104d99454d~mv2.jpg",
          "https://static.wixstatic.com/media/c8fd28_69dbfcc55aa649eeb7b4f12e3b05b89e~mv2.jpg/v1/fill/w_750,h_975,q_90,enc_avif,quality_auto/c8fd28_69dbfcc55aa649eeb7b4f12e3b05b89e~mv2.jpg",
        ],
      },
      {
        title: "Free The Plant — Advocacy",
        description:
          "Editorial and advocacy content around federal legalization, the 2018 Farm Bill, and the broader Free The Plant platform. Positioned Revolution as a category leader on policy — not just a product.",
        layout: "portrait",
        images: [
          "https://static.wixstatic.com/media/c8fd28_bb8bdd1228e1412daadb025c9944febb~mv2.jpg/v1/fill/w_750,h_1325,q_90,enc_avif,quality_auto/c8fd28_bb8bdd1228e1412daadb025c9944febb~mv2.jpg",
          "https://static.wixstatic.com/media/c8fd28_0059b862212a417eab257514892caf9a~mv2.jpg/v1/fill/w_750,h_1325,q_90,enc_avif,quality_auto/c8fd28_0059b862212a417eab257514892caf9a~mv2.jpg",
          "https://static.wixstatic.com/media/c8fd28_41ef03390f294d7ea75a2c46c9f99fc9~mv2.jpg/v1/fill/w_750,h_750,q_90,enc_avif,quality_auto/c8fd28_41ef03390f294d7ea75a2c46c9f99fc9~mv2.jpg",
          "https://static.wixstatic.com/media/c8fd28_8e86f36a21294cf193668425177ff804~mv2.jpg/v1/fill/w_750,h_1325,q_90,enc_avif,quality_auto/c8fd28_8e86f36a21294cf193668425177ff804~mv2.jpg",
        ],
      },
    ],
    gallery: [], // unused when `sections` present
  },
  {
    slug: "sue-bird-monument",
    title: "Sue Bird Monument",
    category: "Cultural Marketing",
    year: "2023",
    client: "Muros × Seattle Storm",
    role: "Senior Marketing Manager — Content, PR, Social Lead",
    timeline: "Unveiled June 2023",
    tagline:
      "A large-scale mural honoring a basketball legend — unveiled the day before her jersey retirement.",
    summary:
      "Led content, PR, and social strategy for a large-scale Sue Bird monument mural unveiled in downtown Seattle the day before her jersey retirement. Earned national press coverage and a personal endorsement from Sue herself.",
    challenge:
      "Create a cultural moment that lived up to the significance of a jersey retirement — and turned a mural into a national news story.",
    approach: [
      "Coordinated press access with the Seattle Storm, Muros leadership, and regional media.",
      "Built multi-channel content coverage across YouTube, Instagram, and local Seattle outlets.",
      "Timed the unveil to maximize coverage inside the jersey-retirement weekend news cycle.",
    ],
    outcome:
      "Coverage across 15+ media outlets, 2M+ social reach, and national press pickup. Sue called the mural \"the best part\" of the celebration weekend.",
    metrics: [
      { k: "15+", v: "Media Outlets" },
      { k: "2M+", v: "Social Reach" },
      { k: "National", v: "Press Tier" },
    ],
    press: [
      {
        title: "Sue Bird Weekend: Honoring Basketball Legend",
        source: "KIRO7 News",
        href: "https://www.kiro7.com/news/local/sue-bird-weekend-seattle-honoring-basketball-legend/3VLAZXWTGBEOJGSL45GAOUDIIM/",
      },
      {
        title: "Storm Build Monument of Love for No. 10",
        source: "Seattle Times",
        href: "https://www.seattletimes.com/sports/storm/storm-do-more-than-retire-sue-birds-jersey-they-build-monument-of-love-for-no-10/",
      },
      {
        title: "The Inside Story of the Seattle Storm's New Mural",
        source: "Muros",
        href: "https://www.muros.com/press/the-inside-story-of-the-seattle-storms-new-mural/",
      },
    ],
    hero: "https://res.cloudinary.com/dxa827voe/images/w_2000,h_1285,c_scale/f_auto,q_auto/v1686613179/Muros_Storm_Original7_v2/Muros_Storm_Original7_v2.jpg",
    gallery: [
      "https://res.cloudinary.com/dxa827voe/images/w_1600,h_1600,c_scale/f_auto,q_auto/v1686613075/Muros_Storm_Original4_v2Sq/Muros_Storm_Original4_v2Sq.jpg",
      "https://res.cloudinary.com/dxa827voe/images/w_2000,h_1311,c_scale/f_auto,q_auto/v1686613712/Muros_Storm_Original5_v2-1/Muros_Storm_Original5_v2-1.jpg",
      "https://www.muros.com/wp-content/uploads/2023/06/Muros_Storm_Original8_v2-1.png",
      "https://res.cloudinary.com/dxa827voe/images/w_2000,h_1333,c_scale/f_auto,q_auto/v1686613400/Muros_Storm_Original2_v2-1/Muros_Storm_Original2_v2-1.jpg",
      "https://res.cloudinary.com/dxa827voe/images/w_2000,h_1333,c_scale/f_auto,q_auto/v1686613454/Muros_Storm_Original1_v2/Muros_Storm_Original1_v2.jpg",
    ],
  },
  {
    slug: "jose-bautista-bat-flip",
    title: "Jose Bautista Bat Flip Mural",
    category: "Cultural Marketing",
    year: "2023",
    client: "Muros × Toronto Blue Jays",
    role: "Senior Marketing Manager — Content, PR & Social Lead",
    timeline: "August 2023",
    tagline:
      "An iconic mural commemorating baseball's most unforgettable moment — and the viral coverage that followed.",
    summary:
      "Content and social strategy for a Toronto Blue Jays mural commemorating Jose Bautista's legendary bat flip. The mural went viral across Reddit, Instagram, and international sports media.",
    challenge:
      "Turn a commemorative mural into a cultural moment that moved well beyond local press — without over-engineering the story.",
    approach: [
      "Partnered with the artist, the Blue Jays, and media to stage a production-content-press pipeline.",
      "Timed social pushes to hit baseball-Reddit and Blue Jays social communities.",
      "Captured in-progress content (including the finishing-touches post that broke 15K Reddit upvotes).",
    ],
    outcome:
      "15K+ Reddit upvotes, 50K+ Instagram likes on partner posts, and international sports media coverage across Canada and the U.S.",
    metrics: [
      { k: "15K+", v: "Reddit Upvotes" },
      { k: "50K+", v: "Instagram Likes" },
      { k: "International", v: "Coverage" },
    ],
    press: [
      {
        title: "Jose Bautista Celebration Mural",
        source: "Muros",
        href: "https://www.muros.com/projects/muros-toronto-blue-jays-jose-bautista-celebration/",
      },
      {
        title: "Mural Commemorates Iconic Bat Flip",
        source: "Sign Media",
        href: "https://www.signmedia.ca/jose-bautista-mural-commemorates-retired-toronto-blue-jays-iconic-bat-flip/",
      },
      {
        title: "Finishing Touches (15K+ upvotes)",
        source: "Reddit",
        href: "https://www.reddit.com/r/Torontobluejays/comments/15nnwrp/sumartist_putting_the_finishing_touches_on_the/",
      },
      {
        title: "Viral Blue Jays Post",
        source: "Instagram",
        href: "https://www.instagram.com/p/Cv6BEVRMZFP/",
      },
    ],
    hero: "https://muralroutes.ca/wp-content/uploads/2023/08/IMG_3338.jpeg",
    gallery: [
      "https://muralroutes.ca/wp-content/uploads/2023/08/IMG_3338.jpeg",
    ],
  },
  {
    slug: "tanger-nashville-murals",
    title: "Tanger Nashville Mural Program",
    category: "Cultural Marketing",
    year: "2023",
    client: "Muros × Tanger Outlets",
    role: "Lead Marketer — Content, Social, Artist Relations, Production, PR",
    timeline: "Opening 2023",
    tagline:
      "One of the largest commercial mural programs in the country — 13 artists, 13 originals, one 290,000 sq ft retail environment.",
    summary:
      "As lead marketer at Muros, owned content, social, artist relations, on-site production and press / comms for the Tanger Outlets Nashville mural program — 13 original installations across a single 290,000 sq ft shopping center.",
    challenge:
      "Coordinate 13 artists, a full retail-opening timeline, and press/social storytelling at national scale — without any link in the chain slipping.",
    approach: [
      "Built the content and social plan around each individual artist, not just the brand.",
      "Ran on-site production content capture (stills + reels) during install across weeks.",
      "Partnered with local press and national architecture/retail media for opening coverage.",
    ],
    outcome:
      "A flagship cultural program for Tanger's opening, with regional press pickup and sustained social engagement across artists, brand, and retailer.",
    metrics: [
      { k: "13", v: "Murals" },
      { k: "290K", v: "Square Footage" },
      { k: "Lead", v: "Marketer & Comms" },
    ],
    press: [
      {
        title: "Tanger Outlets Nashville to Open With 13 New Murals",
        source: "Tennessean",
        href: "https://www.tennessean.com/story/news/local/2023/10/02/tanger-outlets-nashville-to-open-with-13-new-murals/71035305007/",
      },
      {
        title: "Tanger Nashville to Unveil Mural Program",
        source: "Muros",
        href: "https://www.muros.com/press/tanger-nashville-to-unveil-mural-program/",
      },
      {
        title: "Project Page: Tanger Nashville Mural Program",
        source: "Muros",
        href: "https://www.muros.com/projects/muros-tanger-outlets-nashville-mural-program/",
      },
      {
        title: "Artist post — Tanger Nashville",
        source: "Instagram",
        href: "https://www.instagram.com/p/DPeIqf0DTq-/",
      },
      {
        title: "Behind-the-scenes reel",
        source: "Instagram",
        href: "https://www.instagram.com/reel/Cy9xOvmuHKZ/",
      },
    ],
    hero: "https://res.cloudinary.com/dxa827voe/images/w_2000,h_1500,c_scale/f_auto,q_auto/v1698945550/DJI_0100-3/DJI_0100-3.jpg",
    gallery: [
      "https://res.cloudinary.com/dxa827voe/images/w_2000,h_1500,c_scale/f_auto,q_auto/v1698945550/DJI_0100-3/DJI_0100-3.jpg",
    ],
  },
  {
    slug: "behind-the-brush",
    title: "Behind the Brush",
    category: "Content & Creative",
    year: "2023 – 2025",
    client: "Muros",
    role: "Series Creator & Editorial Lead",
    timeline: "Ongoing editorial series",
    tagline:
      "A documentary-style original series profiling the artists behind the murals — brand storytelling over sales.",
    summary:
      "Created and led Behind the Brush, a documentary-style editorial series spotlighting the artists behind Muros' work. The series established Muros as a cultural authority and drove long-term brand equity by centering storytelling over transactional content.",
    challenge:
      "Build durable brand authority in a category where most content is either product pitches or one-off campaign posts.",
    approach: [
      "Designed the editorial format — long-form profile + lifestyle shoot + short-form cutdowns per episode.",
      "Recruited and interviewed artists across the Muros network.",
      "Sequenced releases to build narrative continuity across the artist roster.",
    ],
    outcome:
      "A signature original series that became a pillar of the Muros brand voice and drove measurable long-tail social and SEO performance.",
    metrics: [
      { k: "Original", v: "Series Format" },
      { k: "Brand", v: "Storytelling Pillar" },
      { k: "Authority", v: "Building" },
    ],
    hero: "https://cdn.crevado.com/artists/1287474/pages/5959690_original-2.png",
    gallery: [
      "https://cdn.crevado.com/artists/1287474/artwork/18724062_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18724066_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18724070_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18724098_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18724102_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18724118_original-1.png",
    ],
  },
  {
    slug: "councilor-rebrand",
    title: "Councilor Rebrand",
    category: "Brand Strategy",
    year: "2025",
    client: "Councilor (via JumpSeat)",
    role: "Senior Account Lead / Brand Strategy",
    timeline: "Q1 2025 — Q4 2025",
    tagline:
      "Modernizing a century-old financial institution — without losing the trust its heritage was built on.",
    summary:
      "A comprehensive brand identity transformation and strategic repositioning for a 100-year-old financial institution. Heritage carried forward, modernity earned.",
    challenge:
      "Modernize a 100-year-old financial brand while honoring its heritage and preserving client trust. The existing identity no longer reflected the firm’s ambition or the audiences it needed to reach.",
    approach: [
      "Audited the existing identity, voice, and client-facing content end-to-end.",
      "Rebuilt positioning around continuity and confidence — not nostalgia.",
      "Designed a full visual identity system: marks, typography, palette, motion, and iconography.",
      "Shipped brand guidelines and templates the internal team can operate from long after launch.",
    ],
    outcome:
      "A complete brand architecture including visual identity system, messaging framework, and living brand guidelines. 100% client retention through launch and into year two.",
    metrics: [
      { k: "100%", v: "Client retention" },
      { k: "100 yrs", v: "Heritage carried forward" },
      { k: "Full", v: "Brand system & guidelines" },
    ],
    hero: "https://cdn.crevado.com/artists/1287474/pages/6174442_original-1.jpg",
    gallery: [
      "https://cdn.crevado.com/artists/1287474/artwork/19591622_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591626_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591630_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591634_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591638_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591642_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591646_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591650_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591654_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591658_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591662_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591666_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591670_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591674_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591678_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591682_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591686_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591690_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591694_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591698_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591702_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591706_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591710_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591714_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591718_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591722_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591726_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591730_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591734_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591738_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591742_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591746_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591750_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591754_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591758_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591762_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591766_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591770_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591774_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591778_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/19591782_original-1.jpg",
    ],
  },
  {
    slug: "titan-walls-2024",
    title: "Titan Walls 2024",
    category: "Cultural Marketing",
    year: "2024",
    client: "Muros",
    role: "Senior Marketing Manager",
    timeline: "2024 Season",
    tagline:
      "A large-scale mural program pairing public art with brand partners — built to matter in the cities it touched.",
    summary:
      "Large-scale mural initiative merging public art with strategic brand partnerships — work that lives in the city long after the campaign window closes.",
    challenge:
      "Create authentic cultural relevance while delivering measurable value for sponsor brands — without turning public walls into billboards.",
    approach: [
      "Curated artists first, sponsors second — every brand partnership had to earn its place on the wall.",
      "Built a partnership framework tying brand visibility to artist storytelling and community impact.",
      "Layered local press and multi-channel storytelling around each installation.",
    ],
    outcome:
      "A community-celebrated public art program with significant media coverage and genuine brand integration across every activation.",
    metrics: [
      { k: "Large-scale", v: "Mural installations" },
      { k: "Community", v: "Celebrated program" },
      { k: "Press", v: "Multi-market coverage" },
    ],
    hero: "https://cdn.crevado.com/artists/1287474/pages/5961018_original-5.jpg",
    gallery: [
      "https://cdn.crevado.com/artists/1287474/artwork/18729686_original.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18729690_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18729694_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18729698_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18729702_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18729706_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18729710_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18729714_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18729718_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18729722_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18729726_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18729730_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18729734_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18729738_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18729742_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18729746_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18729670_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18729674_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18729678_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18729682_original-1.jpg",
    ],
  },
  {
    slug: "choose-chicago-at-art-basel",
    title: "Choose Chicago at Art Basel",
    category: "Destination Marketing",
    year: "2023",
    client: "Choose Chicago × Muros",
    role: "Senior Marketing Manager",
    timeline: "Art Basel Miami 2023",
    tagline:
      "Positioning Chicago as an international cultural destination — at the world's most important art fair.",
    summary:
      "Strategic brand presence at the premier international art fair, positioning Chicago as a cultural destination on par with anywhere in the world.",
    challenge:
      "Stand out in a saturated luxury market and capture high-net-worth attention without over-spending or over-performing the moment.",
    approach: [
      "Anchored the activation in the art itself — Chicago artists, Chicago stories, credible work.",
      "Designed a physical presence that invited conversation rather than performative photography.",
      "Built press and VIP pathways so the right audiences knew Chicago was there.",
    ],
    outcome:
      "A premium activation that elevated the city brand among cultural influencers and decision-makers, supported by meaningful press coverage.",
    metrics: [
      { k: "Premium", v: "Activation" },
      { k: "VIP", v: "Reach & access" },
      { k: "Media", v: "Coverage secured" },
    ],
    hero: "https://cdn.crevado.com/artists/1287474/pages/5960250_original-4.jpg",
    gallery: [
      "https://cdn.crevado.com/artists/1287474/artwork/18728566_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18726318_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18728578_original-4.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18728590_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18728594_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18728582_original-4.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18728550_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18728610_original-2.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18728598_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18728542_original.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18728546_original-4.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18728606_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18728554_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18728558_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18728562_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18726310_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18726314_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18726322_original-1.png",
    ],
  },
  {
    slug: "beach-house-activation",
    title: "Beach House Activation",
    category: "Experiential Marketing",
    year: "2024",
    client: "Muros",
    role: "Senior Marketing Manager",
    timeline: "Seasonal activation",
    tagline:
      "An immersive brand home designed to earn organic reach and lasting affinity.",
    summary:
      "A full-season experiential activation where the brand lived inside a physical space — built for conversation, community, and organic social amplification.",
    challenge:
      "Translate brand values into a physical experience with real staying power beyond the first Instagram story.",
    approach: [
      "Treated the house itself as a narrative — every room contributing to the larger brand story.",
      "Integrated partner brands without allowing any single one to hijack the experience.",
      "Choreographed moments designed to be shared organically, never performatively.",
    ],
    outcome:
      "A high-impact activation that generated sustained organic social reach and durable brand affinity across the season.",
    metrics: [
      { k: "Organic", v: "Social reach" },
      { k: "Seasonal", v: "Brand presence" },
      { k: "Partner", v: "Alignment" },
    ],
    hero: "https://cdn.crevado.com/artists/1287474/pages/5960214_original-2.jpg",
    gallery: [
      "https://cdn.crevado.com/artists/1287474/artwork/18729750_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18729754_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18729758_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18729762_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18725850_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18725818_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18725810_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18725846_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18725814_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18725822_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18725826_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18725830_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18725834_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18725838_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18725842_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18725854_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18725858_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18725862_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18725802_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18725806_original-1.jpg",
    ],
  },
  {
    slug: "the-raquet-club",
    title: "The Raquet Club",
    category: "Brand Development",
    year: "2024",
    client: "The Raquet Club",
    role: "Brand Development / Creative Direction",
    timeline: "Multi-phase launch",
    tagline:
      "Premium lifestyle positioning for an exclusive athletic and social club — confident, considered, quietly luxurious.",
    summary:
      "A complete brand development program for a premium athletic and social club — identity, voice, and member communications designed to earn their price tag without shouting.",
    challenge:
      "Build an aspirational brand identity that resonates with affluent audiences without defaulting to luxury clichés.",
    approach: [
      "Defined the target member persona and the in-person experience they expected.",
      "Designed a sport-forward visual system with restraint and editorial discipline.",
      "Authored member-facing communications aligned to the in-club tone — warm, exclusive, unfussy.",
    ],
    outcome:
      "A sophisticated brand ecosystem driving membership growth and community engagement since launch.",
    metrics: [
      { k: "Premium", v: "Positioning" },
      { k: "Growth", v: "Membership momentum" },
      { k: "Unified", v: "Brand ecosystem" },
    ],
    hero: "https://cdn.crevado.com/artists/1287474/pages/5960230_original-1.jpg",
    gallery: [
      "https://cdn.crevado.com/artists/1287474/artwork/18729590_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18729594_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18729598_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18729602_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18726302_original.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18726246_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18726250_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18726254_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18726258_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18726262_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18726266_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18726270_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18726274_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18726278_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18726282_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18726286_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18726290_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18726294_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18726298_original-1.jpg",
    ],
  },
  {
    slug: "jp-grazianos-popup",
    title: "JP Graziano's Popup",
    category: "Experiential Marketing",
    year: "2023",
    client: "JP Graziano Grocery Co.",
    role: "Marketing Consultant",
    timeline: "Limited run",
    tagline:
      "A heritage Chicago sandwich institution — reintroduced to the city through a sold-out popup program.",
    summary:
      "A limited-time experiential program for a heritage food brand with a cult following. Scarcity, story, and strategic partnerships turned a one-weekend run into ongoing customer acquisition.",
    challenge:
      "Generate buzz and sustained foot traffic in a highly competitive culinary market without diluting the brand's 100-year legacy.",
    approach: [
      "Built the program around scarcity and story — once, here, then gone.",
      "Partnered locally across media, culture, and food to pull in overlapping audiences.",
      "Captured content designed to outlive the activation and support ongoing marketing.",
    ],
    outcome:
      "Sold-out events with waitlists, significant social engagement, and a measurable lift in new customers who converted into regulars.",
    metrics: [
      { k: "Sold-Out", v: "Events & waitlists" },
      { k: "New", v: "Customer acquisition" },
      { k: "Press", v: "& social pickup" },
    ],
    hero: "https://cdn.crevado.com/artists/1287474/pages/5960774_original-2.jpg",
    gallery: [
      "https://cdn.crevado.com/artists/1287474/artwork/18728622_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18728626_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18728630_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18728634_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18728638_original-1.jpg",
      "https://cdn.crevado.com/artists/1287474/artwork/18728642_original-1.jpg",
    ],
  },
  {
    slug: "int-womens-day-muros",
    title: "International Women's Day · Muros",
    category: "Purpose-Driven Marketing",
    year: "2024",
    client: "Muros",
    role: "Senior Marketing Manager",
    timeline: "March 2024",
    tagline:
      "A purpose-driven campaign centering female artists — with presence built to last past the holiday.",
    summary:
      "An International Women's Day campaign spotlighting the women artists in the Muros network. Authentic advocacy over performative participation.",
    challenge:
      "Create meaningful advocacy on a date where most brand participation lands as performative.",
    approach: [
      "Let the artists lead — their words, their work, their framing.",
      "Built multi-channel storytelling designed to live past March 8.",
      "Paired the digital campaign with real-world mural work and partner support.",
    ],
    outcome:
      "A visual campaign with community impact and brand-value alignment that continued resonating long after the news cycle moved on.",
    metrics: [
      { k: "Artist-Led", v: "Campaign" },
      { k: "Post-IWD", v: "Lifespan" },
      { k: "Authentic", v: "Advocacy" },
    ],
    hero: "https://cdn.crevado.com/artists/1287474/pages/5960862_original-2.png",
    gallery: [
      "https://cdn.crevado.com/artists/1287474/artwork/18729570_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18729566_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18729586_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18729582_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18729574_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18729578_original-1.png",
    ],
  },
  {
    slug: "revenue-generating-advertisements",
    title: "Revenue Generating Advertisements",
    category: "Performance Marketing",
    year: "2023 – 2024",
    client: "Muros",
    role: "Senior Marketing Manager",
    timeline: "Rolling, multi-quarter",
    tagline:
      "Performance advertising that earned its budget — brand integrity intact.",
    summary:
      "A data-driven advertising program across Google Ads, LinkedIn, and CCTV networks — ads that generated measurable ROI without sacrificing brand taste.",
    challenge:
      "Maximize marketing-driven revenue in competitive markets without sacrificing the brand equity the creative team had built.",
    approach: [
      "Unified creative strategy across paid search, paid social, display, and out-of-home.",
      "A/B-tested copy, visuals, and channel mix every cycle.",
      "Built attribution and reporting the leadership team could actually read.",
      "Paired every performance ad with a brand-story counterpart to protect long-term equity.",
    ],
    outcome:
      "A multi-channel campaign architecture with ongoing performance optimization — contributing to 550%+ marketing-driven revenue growth over the engagement.",
    metrics: [
      { k: "550%+", v: "Marketing revenue growth" },
      { k: "4+", v: "Channels unified" },
      { k: "Continuous", v: "A/B testing cadence" },
    ],
    hero: "https://cdn.crevado.com/artists/1287474/pages/5968630_original-1.png",
    gallery: [
      "https://cdn.crevado.com/artists/1287474/artwork/18756730_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756734_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756738_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756742_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756746_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756750_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756754_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756758_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756762_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756766_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756770_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756774_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756778_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756782_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756786_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756790_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756794_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756798_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756802_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756806_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756810_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756814_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756818_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756822_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756826_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756830_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756834_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756838_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756842_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756846_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756850_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756854_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756858_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756862_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756866_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756870_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756874_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756878_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756882_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756886_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756890_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756894_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756898_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756902_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756906_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756910_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756914_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756710_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756714_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756718_original-1.png",
      "https://cdn.crevado.com/artists/1287474/artwork/18756722_original-1.png",
    ],
  },
  {
    slug: "chicago-addy-awards-2023",
    title: "Chicago Addy Awards 2023",
    category: "Event Marketing",
    year: "2023",
    client: "Muros (Strategic Sponsor)",
    role: "Senior Marketing Manager",
    timeline: "Chicago Addy Awards 2023",
    tagline:
      "An executive-level sponsorship activation inside the creative industry's leadership audience.",
    summary:
      "A strategic sponsorship of the Chicago Addy Awards — built to put Muros in front of agency leadership, creative directors, and decision-makers in a way a logo on a step-and-repeat never could.",
    challenge:
      "Maximize brand presence at a peer-heavy industry event without defaulting to standard-issue sponsorship visibility.",
    approach: [
      "Positioned the sponsorship around contributed value — talks, moments, connections — rather than logo placement.",
      "Activated pre-event, on-site, and post-event to compound the impression.",
      "Captured content and case material for long-tail marketing and thought leadership.",
    ],
    outcome:
      "A sponsorship activation that generated the kind of warm introductions and agency conversations most event sponsorships aspire to.",
    metrics: [
      { k: "Agency", v: "Relationships" },
      { k: "Leadership", v: "Visibility" },
      { k: "Long-tail", v: "Content" },
    ],
    hero: "https://cdn.crevado.com/artists/1287474/pages/5971966_original-3.jpg",
    gallery: [
      "https://cdn.crevado.com/artists/1287474/pages/5971966_original-3.jpg",
    ],
  },
];

export const getProjectBySlug = (slug) => PROJECTS.find((p) => p.slug === slug);
export const getAdjacentProjects = (slug) => {
  const i = PROJECTS.findIndex((p) => p.slug === slug);
  if (i === -1) return { prev: null, next: null };
  return {
    prev: PROJECTS[(i - 1 + PROJECTS.length) % PROJECTS.length],
    next: PROJECTS[(i + 1) % PROJECTS.length],
  };
};
